import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import { validateField } from "@/utils/helper"
import { callNotification } from "@/components/ProductDetail/v3/AddToCart/utils"
import Input from "@/components/core/Input/Input"
import Style from "@/components/PartsViewer/v2/NotifyMe/notify.module.scss"
import PropTypes from "prop-types"

const NotifyItems = props => {
  const {
    item,
    fromCart,
    isListExtend,
    gridViewNotify,
    showStockMessage = true,
    itemStock = false,
  } = props
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState({ show: false, message: "" })
  const [showWelcome, setShowWelcome] = useState(false)
  const [enableNotify, setEnableNotify] = useState(false)
  const { t } = useTranslation("common")
  const {
    notifyText,
    notifySuccessText,
    notifyEmailText,
    successText,
    notifyOutofStockText,
    notifyButtonText,
  } = getTranslations(t)

  useEffect(() => {
    setShowWelcome(false)
    setEmailError({ show: false, message: "" })
    setEmail("")
  }, [item])

  const handleEmailChange = async val => {
    const inputValue = val.trim()
    setEmailError({ show: false, message: "" })
    setEmail(inputValue)
    if (!(await validateField("email", inputValue))) {
      setEnableNotify(false)
    } else {
      setEnableNotify(true)
    }
  }

  const callBackNotify = isSuccess => {
    if (isSuccess) {
      setShowWelcome(true)
      setEmail("")
      setEnableNotify(false)
    } else {
      setEmailError({
        show: true,
        message: notifyText,
      })
    }
  }

  const handleNotification = () => {
    const sku = item?.currentVarent?.id
    if (sku) callNotification({ email, sku, callBackNotify })
  }

  const handlerSubmit = event => {
    if (event.key === "Enter" && enableNotify) {
      handleNotification()
    }
  }

  const handlerNotify = () => {
    if (enableNotify) {
      handleNotification()
    }
  }

  const outofStockVal = !itemStock ? notifyOutofStockText : null
  const notifytextVal = !itemStock ? notifyEmailText : null

  return (
    <div className={Style?.NotifyContianer}>
      <Row className={gridViewNotify ? "girdViewNotify" : ""}>
        <Col className="notify-contianer">
          {showStockMessage || itemStock ? (
            <div
              className={`notify-message notify-button-margin ${
                isListExtend ? "notify-button-margin" : ""
              }`}
            >
              <p className={`fs-16 fw-500 notify-heading `}>
                {showWelcome ? successText : outofStockVal}
              </p>

              <p className={`fs-14 fw-400 notify-details `}>
                {showWelcome ? notifySuccessText : notifytextVal}
              </p>
            </div>
          ) : null}
          {!showWelcome ? (
            <div className={`${fromCart ? "input-button" : ""}`}>
              <div className="email-inputbox">
                <Input
                  id="email-notify"
                  onChange={e => handleEmailChange(e.target.value)}
                  onKeyDown={handlerSubmit}
                  type="email"
                  label="Email Address"
                  ariaRequried={true}
                  maxLength={60}
                  value={email}
                  showError={emailError.show}
                  errorMessage={emailError.message}
                />
              </div>
              <div className="notify-button-div">
                <button
                  className={`notify-button ${
                    !isListExtend
                      ? "notify-button-margin"
                      : "notify-button-width"
                  } ${enableNotify ? "" : "disabled-btn"}`}
                  onClick={handlerNotify}
                  disabled={!enableNotify}
                >
                  {notifyButtonText}
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>
    </div>
  )
}

NotifyItems.propTypes = {
  item: PropTypes.object.isRequired,
  fromCart: PropTypes.string.isRequired,
  isListExtend: PropTypes.bool.isRequired,
  gridViewNotify: PropTypes.object.isRequired,
  showStockMessage: PropTypes.string.isRequired,
  itemStock: PropTypes.bool.isRequired,
}

export default NotifyItems
